import * as React from 'react';

import styled from '@emotion/styled';

import { observer } from 'src/utils/mobx-react';



const SvgElement = styled('svg', { label: 'SvgElement' })`

    height: auto;

`;



interface PropsType {

    className?: string;

    onClick?: () => void;

}



export const DragonBetBrandIconGradient = observer(

    'DragonBetBrandIconGradient',

    ({ className, onClick }: PropsType): JSX.Element => (

        <SvgElement

            className={className}

            onClick={onClick}

            fill='#fff'

            width='24'

            height='24'

            viewBox='0 0 24 24'

            xmlns='http://www.w3.org/2000/svg'

        >

            <path

                fill='url(#dragonBetBrandIcon_a)'

                fillRule='evenodd'

                d='M21.9923 13.2601c0 5.4727-4.5242 9.8235-10.1632 9.7341-5.427-.2315-9.6965-5.0606-9.2978-10.469.067-.9153.269-1.8084.5855-2.655a.0258.0258 0 0 0-.0241-.0348c-.1708-.0036-.481.143-1.0406.4863-.0214.0125-.0492-.0045-.0438-.0295.2405-1.1907 1.7289-2.5182 2.563-3.1824.2038-.1619.0446-.4908-.2075-.4282-.1752.0438-.37.1215-.573.252-.0223.0143-.051-.0071-.0411-.0321.413-1.0683 1.399-1.7343 1.6484-1.889.0206-.0124.0134-.0437-.0098-.0482-1.7852-.3415-2.6058-.4479-2.8115-2.4682a.028.028 0 0 1 .0438-.0259c1.7477 1.1943 3.8664 1.0674 5.8795 1.248.5882.0527 1.2086.093 1.7539.336.5382.2396 1.0057.6428 1.307 1.1506.1126.1895.2047.395.3575.5533.144.1493.3317.2485.5212.3326.5489.2449 1.1353.3915 1.7217.5149.5158.1081.9986.2235 1.3025.7.1788.2797.32.6025.3996.7929.0107.025-.0188.0473-.0411.0312-.4783-.3397-.7626-.3379-1.0093-.177-.6168.4032-.5721.893-1.1791 1.2104-.0197.0108-.0438-.0071-.0393-.0286.2288-1.113-4.8568-2.3492-5.3404-.742a.0273.0273 0 0 0 .016.0322c.8976.3442 1.677 1.3937 3.2424 1.332.0214 0 .0348.0224.0223.0393-.1493.2003-.7294 1.0808-.2217 2.0722a.0328.0328 0 0 1-.0098.0393c-2.1115 1.4178.8403-2.234-3.507-.9091a.0318.0318 0 0 0-.0187.017 4.0706 4.0706 0 0 0-.1993.565c-.0054.0196.0134.0384.033.0321.5069-.143 1.0361-.244 1.5796-.2896.0313-.0027.0411.042.0107.0527-2.0757.6946-.9314 2.8419 1.0147 4.1515.0241.017.0089.0545-.0197.0501-.8725-.1475-1.6341-.3192-2.3001-.5087a.0255.0255 0 0 0-.0304.0349c1.3784 3.2843 6.0314 3.911 8.1983.9824.8153-1.1022 1.0254-2.3421.8251-3.5954a.0279.0279 0 0 1 .0286-.0322c1.3839.034 2.0722-.6597 2.4459-.9458a.0427.0427 0 0 0-.0036-.0697c-1.3382-.8761-2.0284-1.6216-3.009-2.4637a.0291.0291 0 0 1-.0072-.0322c.2092-.4505.6481-.084.7402-.665.3031-1.9176-2.9661-2.6622-3.7411-2.8965-1.34-.53-.5087-1.0298-2.4602-1.9773 6.4847-.6401 11.1073 4.1952 11.1073 9.8503l.0017.0018ZM6.461 2.1582c-1.8218-.0465-1.972-.539-2.8213-1.1532-.0187-.0134-.0455.0018-.0429.0242.0814.7473.2763 1.4893 1.1112 1.8469 1.1872.5068 2.4932.26 3.3871.3244.0206.0018.034-.0187.026-.0375-.2289-.5426-.3782-.9726-1.66-1.0048Zm4.2668 6.1226c.9637 2.1696 4.3356 2.7712 4.821 2.8472.0224.0036.0304.0322.0125.0474l-.5694.4756c-.0179.0152-.0098.0438.0125.0474.2476.0339 1.2927.1349 3.3192-.1958.0259-.0045.0313-.0394.0081-.051-1.5162-.7938-2.4342-1.88-2.6667-2.1767-.017-.0215-.0509-.0072-.0473.0205l.092.7679a.0275.0275 0 0 1-.0295.0304c-2.8114-.3057-4.5251-1.5375-4.9113-1.8424-.0214-.017-.0527.0063-.0411.0322v-.0027Z'

                clipRule='evenodd'

            />

            <path

                fill='url(#dragonBetBrandIcon_b)'

                d='M21.9476 14.1621c-3.481 6.1771-10.5833 7.0085-11.926 6.2933 1.4151-.4165 4.6663-1.4446 5.6336-3.0698-3.2629 1.2194-6.4999.456-7.7809-2.2536-.0134-.0313.0152-.0652.0483-.0554.6615.1868 1.4169.3558 2.2795.5024.0269.0045.0412-.0304.0188-.0456-1.9523-1.3105-3.0796-3.4497-1.0182-4.1541.0313-.0108.0215-.0581-.0116-.0555a8.358 8.358 0 0 0-1.5832.2906.0226.0226 0 0 1-.0277-.0277c.0537-.1976.1171-.38.1994-.5668a.04.04 0 0 1 .0214-.0188c4.3482-1.3248 1.3883 2.3252 3.498.9092.0125-.009.0179-.0278.0107-.0412-.5149-1.0048.0903-1.8781.228-2.0694.0116-.017 0-.0412-.0224-.0394-1.551.0528-2.3287-.9627-3.2155-1.3203-.033-.017-.0527-.0054-.033-.076.514-1.3677 4.3678-.5802 5.2161.3915-.4353-1.8048-4.9783-3.1493-6.894-.4585a.0255.0255 0 0 0 0 .0294c.3969.5337 1.0414.8046 2.2732 1.2855a.0255.0255 0 0 1-.0062.0492c-2.4995.0027-2.6032 1.8594-2.436 2.9768.1716-.0581.8385-.3039.978-.2959.0098-.0044.0205.0054.017.0161-.431 1.0611.3039 1.7897.5175 1.9873.0134.0125.0036.0357-.0152.0348-.9556-.034-1.6573-.4514-1.8361-.5685-.0152-.0099-.0349.0044-.0304.0223.126.4452 1.0995 3.6232 3.5248 4.6825.0223.0098.017.0429-.0071.0447-3.7206.2574-6.4579-3.0868-6.8709-3.6187-.0134-.0179-.042-.0045-.0384.0179.4541 2.4512 1.8478 4.6288 3.801 6.0984 2.6765 2.0409 5.3127 1.9363 5.3672 1.9372 3.4837.1082 9.1817-1.9425 10.1185-8.833l.0018-.0009Z'

            />

            <defs>

                <linearGradient

                    id='dragonBetBrandIcon_a'

                    x1='9.6747'

                    x2='28.4269'

                    y1='11.9978'

                    y2='11.9978'

                    gradientUnits='userSpaceOnUse'

                >

                    <stop stopColor='#E20613' />

                    <stop offset='1' stopColor='#812326' />

                </linearGradient>

                <linearGradient

                    id='dragonBetBrandIcon_b'

                    x1='-1.6765'

                    x2='39.2463'

                    y1='14.8871'

                    y2='14.8871'

                    gradientUnits='userSpaceOnUse'

                >

                    <stop offset='.09' stopColor='#E20613' />

                    <stop offset='.18' stopColor='#DD0713' />

                    <stop offset='.28' stopColor='#CE0B16' />

                    <stop offset='.4' stopColor='#B7121B' />

                    <stop offset='.52' stopColor='#961C21' />

                    <stop offset='.59' stopColor='#812326' />

                </linearGradient>

            </defs>

        </SvgElement>

    )

);

